export default __webpack_public_path__ + "static/media/planUpgradeSuccessImage.55001de2.png";